import { getPinia } from '@/createPiniaSingleton';
import { useBulkInvoiceCreateStore } from '@/stores/billing/useBulkInvoiceCreateStore';
angular.module('leanlaw').controller('InvoiceStagingCtrl', ['$scope', '$q', '$state', '$filter', 'userService', 'leanLawApi', 'invoiceFilterService', 'alerts', 'onboardService', 'singleRequest', function ($scope, $q, $state, $filter, userService, leanLawApi, invoiceFilterService, alerts, onboardService, singleRequest) {
  // The chunk-submit loop itself lives in useBulkInvoiceCreateStore -- as a singleton outside
  // this controller's $scope, a run survives an in-app navigation instead of needing this
  // controller (and a navigation guard) to stay alive for the whole submission. See the store
  // for CHUNK_SIZE/timeout/batchKey handling.
  const bulkCreateStore = useBulkInvoiceCreateStore(getPinia());
  $scope.selectedCount = 0;
  $scope.currPage = 1;
  $scope.pageSize = 15;
  $scope.pageSizePrev = $scope.pageSize;
  $scope.lastPage;
  $scope.calcLastPage = calcLastPage;
  $scope.state = invoiceFilterService.state;
  $scope.data = {
    quickbooks: false,
    clients: [],
    totals: {}
  };
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.include = {
    billable: true,
    nonBillable: true,
    charges: true,
    expenses: true,
    chargeHours: true
  };

  // Function to generate comma-separated string of checked checkboxes
  function getCheckboxesChecked() {
    const checkboxMapping = {
      billable: 'billable time',
      nonBillable: 'non billable time',
      chargeHours: 'fixed fee time',
      charges: 'fixed fee',
      expenses: 'expenses'
    };
    const checkedBoxes = [];
    Object.keys(checkboxMapping).forEach(key => {
      if ($scope.include[key]) {
        checkedBoxes.push(checkboxMapping[key]);
      }
    });
    return checkedBoxes.join(', ');
  }
  let blockOtherApiCalls = true;
  $scope.setRate = function () {
    $scope.me.rates.standard = $scope.rate;
    $scope.saving = true;
    userService.update({
      id: $scope.me.id,
      rates: $scope.me.rates
    }).then(me => {
      $scope.me = me;
      $scope.rateAsk = false;
      stateUpdated(true);
    }).finally(() => {
      $scope.saving = false;
    });
  };
  $scope.selectAll = function (all) {
    $scope.included = all;
    $scope.data.clients.forEach(c => {
      c.included = all;
      c.matters.forEach(m => {
        m.included = all;
      });
    });
  };
  $scope.includeChange = function (event) {
    event.stopPropagation();
    $scope.included = _.find($scope.data.clients, c => c.included || _.find(c.matters, m => m.included));
  };
  let filterReadyPromise;
  let resolveFilterReady;
  filterReadyPromise = new Promise(resolve => {
    resolveFilterReady = resolve;
  });
  $scope.filterReady = function () {
    return filterReadyPromise;
  };
  $scope.createClient = createClient;
  $scope.createMatter = createMatter;
  $scope.createSelected = createSelected;
  $scope.filteredEntities = filteredEntities;
  $scope.clicked = clicked;
  $scope.rowChecked = rowChecked;
  $scope.selectColumn = selectColumn;

  // Guards the trailing refresh/alert logic in runBulkCreate against running against a dead
  // scope -- the store's run keeps going after an in-app navigation destroys this controller,
  // but this controller instance shouldn't act on it once it's gone. The next controller
  // instance (a fresh RTB visit) picks results back up via bulkCreateStore.applyResultsToRows
  // after its own initial fetch below.
  let destroyed = false;
  $scope.$on('$destroy', () => {
    destroyed = true;
  });

  // Bridges the store's progress (Vue reactivity) onto $scope (AngularJS digest) for the
  // Create-button label -- copies on every store patch and schedules a digest. Also covers
  // the case where a run is already in progress when this controller is (re)created, e.g. the
  // user started a batch, navigated to Trust, and came back before it finished.
  const syncBulkCreateState = () => {
    $scope.creating = bulkCreateStore.creating;
    $scope.creatingTotal = bulkCreateStore.creatingTotal;
    $scope.creatingProcessed = bulkCreateStore.creatingProcessed;
    $scope.creatingChunk = bulkCreateStore.creatingChunk;
    $scope.creatingChunkTotal = bulkCreateStore.creatingChunkTotal;
  };
  syncBulkCreateState();
  const unsubscribeBulkCreateStore = bulkCreateStore.$subscribe(() => {
    syncBulkCreateState();
    $scope.$applyAsync();
  });
  $scope.$on('$destroy', unsubscribeBulkCreateStore);
  activate();

  ////////////////////////////

  let lastRequestParams = null;
  // Was an undeclared assignment -- silently created an implicit global in the sloppy-mode
  // script this file used to be. Adding the ES `import`s above makes this an ES module, which
  // is always strict mode, so the same assignment now throws ReferenceError instead.
  let _loadedState = null;
  function activate() {
    $scope.loading = true;
    let isInitializing = true;
    let allFiltersReady = false;
    let filterUpdateTimer = null;
    let pendingUpdate = false;
    blockOtherApiCalls = true;
    const checkIfAllFiltersAreSet = () => {
      const hasRange = !!invoiceFilterService.state.range;
      const hasScope = !!invoiceFilterService.state.filter.scope;
      const needsAccount = invoiceFilterService.state.filter.scope === 'primary';
      const hasAccount = !!invoiceFilterService.state.filter.scopeAccount;
      return hasRange && hasScope && (!needsAccount || hasAccount);
    };
    $scope.$on('matterFilter:accountSelected', function (event, account) {
      invoiceFilterService.state.filter.scopeAccount = account;

      // Don't force an immediate load unless every filter (including
      // `scope`) is actually set -- `scope` isn't assigned until
      // MatterFilterController's own activate() calls scopeChange(),
      // which happens after this event fires.
      if (blockOtherApiCalls && checkIfAllFiltersAreSet()) {
        allFiltersReady = true;
        isInitializing = false;
        // This will skip the debounce and immediately call the API
        pendingUpdate = false;
        stateUpdated(true);
      }
    });
    userService.me().then(me => {
      $scope.me = me;
      $scope.$watch('state', (newState, oldState) => {
        if (JSON.stringify(newState) !== JSON.stringify(oldState)) {
          scheduleApiCall();
        }
      }, true);
      const scheduleApiCall = () => {
        if (filterUpdateTimer) {
          clearTimeout(filterUpdateTimer);
        }
        const delay = isInitializing ? 300 : 200;
        filterUpdateTimer = setTimeout(() => {
          if (isInitializing && !allFiltersReady) {
            const hasAllFilters = checkIfAllFiltersAreSet();
            if (!hasAllFilters) {
              filterUpdateTimer = setTimeout(scheduleApiCall, 100);
              return;
            }
            allFiltersReady = true;
            isInitializing = false;
          }

          // Only prevent duplicate calls during initialization
          if (pendingUpdate && isInitializing) return;
          pendingUpdate = true;
          stateUpdated(false) // Changed from isInitializing to false to always force update
          .then(() => {
            blockOtherApiCalls = false;
            if (!$scope.data.unassigned) {
              leanLawApi.listExpenses({
                assigned: false
              }).then(list => {
                $scope.data.unassigned = list.expenses;
              });
            }
          }).finally(() => {
            pendingUpdate = false;
            filterUpdateTimer = null;
          });
        }, delay);
      };
      $scope.draft = me.company.settings.workflow && me.company.settings.workflow.invoiceDraft;
      $scope.tooltip = 'One-click create draft invoice';
      if (!$scope.draft) {
        $scope.tooltip = 'One-click create invoice and send it to QuickBooks';
      }
      $scope.data.quickbooks = me.company.integration.quickbooks;
      $scope.me = me;
      if (isNaN(me.rates.standard)) {
        $scope.rateAsk = true;
      }
      $scope.readonly = !me.permissions.billing.create;
      let previousState = null;
      $scope.$watch(() => {
        const stateToWatch = {
          range: JSON.stringify(invoiceFilterService.state.range),
          // Stringify to detect all changes
          scope: invoiceFilterService.state.filter.scope,
          scopeAccount: invoiceFilterService.state.filter.scopeAccount?.id,
          clientId: invoiceFilterService.state.cm.client?.id,
          matterId: invoiceFilterService.state.cm.matter?.id
        };
        const currentStateString = JSON.stringify(stateToWatch);
        if (currentStateString !== previousState) {
          previousState = currentStateString;
          return currentStateString;
        }
        return previousState;
      }, () => {
        scheduleApiCall();
      });
      scheduleApiCall();
    });
  }
  function filteredEntities(entities) {
    return $filter('filter')(entities, $scope.query);
  }
  function calcLastPage() {
    $scope.lastPage = Math.ceil($scope.numClients / $scope.pageSize);
  }
  function buildRequest() {
    const request = invoiceFilterService.filterQuery();
    request.data = 'hours,services,expenses,charges';
    request.billed = false;
    request.status = 'active';
    request.primary = 'clients';
    request.source = 'billing';
    request.zeros = false;
    request.chargeCompleted = true;
    if (invoiceFilterService.state.includeContingency) {
      request.billingType = 'contingency';
    } else {
      request.billingType = '-internal,-contingency';
    }
    request.nonbillable = !!invoiceFilterService.state.includeNonBillable;

    // Add custom field filters to request
    addCustomFieldsToRequest(request);
    if (invoiceFilterService.state.filter.scopeAccount) {
      if (typeof invoiceFilterService.state.filter.scopeAccount === 'object') {
        request.scopeAccount = invoiceFilterService.state.filter.scopeAccount.id;
      } else {
        request.scopeAccount = invoiceFilterService.state.filter.scopeAccount;
      }
    }
    if (invoiceFilterService.state.expenseRange) {
      const expenseRequest = invoiceFilterService.expenseFilterQuery();
      request.expenseRange = true;
      request.expenseStartDate = expenseRequest.startDate;
      request.expenseEndDate = expenseRequest.endDate;
    }
    return request;
  }
  function addCustomFieldsToRequest(request) {
    const customFields = invoiceFilterService.state.filter.customFields;
    const customFieldMeta = invoiceFilterService.state.filter.customFieldMeta;
    if (!customFields || !customFieldMeta) {
      return;
    }
    let clientFieldIndex = 0;
    let matterFieldIndex = 0;
    Object.entries(customFields).forEach(([fieldId, optionId]) => {
      // Skip if empty string, null, or undefined (deselected)
      if (!optionId || optionId === '') {
        return;
      }

      // Get the field metadata to determine entity type
      const fieldMeta = customFieldMeta[fieldId];
      if (!fieldMeta) {
        return;
      }
      if (fieldMeta.entity === 'client') {
        request[`clientcustomfield[${clientFieldIndex}].fieldid`] = fieldId;
        // Only include optionid if not filtering for "Not assigned"
        if (optionId !== 'NOT_ASSIGNED') {
          request[`clientcustomfield[${clientFieldIndex}].optionid`] = optionId;
        }
        clientFieldIndex++;
      } else if (fieldMeta.entity === 'matter') {
        request[`mattercustomfield[${matterFieldIndex}].fieldid`] = fieldId;
        // Only include optionid if not filtering for "Not assigned"
        if (optionId !== 'NOT_ASSIGNED') {
          request[`mattercustomfield[${matterFieldIndex}].optionid`] = optionId;
        }
        matterFieldIndex++;
      }
    });
  }
  function resetFlags() {
    blockOtherApiCalls = false;
    $scope.loading = false;
  }
  function stateUpdated(force) {
    _loadedState = angular.copy(invoiceFilterService.state);
    if (_loadedState.range && !force) {
      force = true;
    }

    // Check conditions before setting loading state
    if (!force && !invoiceFilterService.reload(_loadedState)) {
      resetFlags();
      return $q.resolve();
    }
    const request = buildRequest();
    const requestHash = JSON.stringify(request);
    if (!force && requestHash === lastRequestParams) {
      resetFlags();
      return $q.resolve();
    }

    // Only set loading to true when we know we'll make the API call
    $scope.loading = true;
    lastRequestParams = requestHash;
    singleRequest.cancel("r2b");
    singleRequest.cancel("listClients");
    singleRequest.cancel("listMatters");
    return singleRequest.apiCall('r2b').getReport(request).then(list => {
      if (!list) {
        resetFlags();
        return;
      }
      $scope.data.clients = list.clients || [];
      $scope.data.totals = list.data;
      $scope.numClients = $scope.data.clients.length;
      calcLastPage();
      $scope.included = false;
      $scope.all = false;
      $scope.data.clients.forEach(client => {
        client.included = $scope.included;
        client.include = angular.copy($scope.include);
        client.matters.forEach(matter => {
          matter.included = $scope.included;
          matter.include = angular.copy($scope.include);
        });
      });
      // Reapplies any lingering error from a run that finished (or is still going, for an
      // earlier chunk) without this controller around to see it -- e.g. the user navigated
      // away mid-batch and came back. See useBulkInvoiceCreateStore.
      bulkCreateStore.applyResultsToRows($scope.data.clients);
      resetFlags();
      return list;
    }).catch(err => {
      if (err && err.status !== 0) {
        alerts.error(err);
      }
      resetFlags();
      return $q.reject(err);
    });
  }
  function visibleClients() {
    // filterFilter/orderByFilter both pass a null/undefined array straight through instead of
    // throwing (see angular.js filterFilter/orderByFilter: `if (array == null) return array;`),
    // so a bad upstream value silently turns into a non-array here rather than erroring where
    // it's actually introduced. This is the one place that guarantee has to hold, since every
    // caller relies on getting an array back.
    const clients = $filter('orderBy')(filteredEntities($scope.data.clients || []), $scope.sort, $scope.reverse) || [];
    const start = ($scope.currPage - 1) * $scope.pageSize;
    const end = start + $scope.pageSize;
    return clients.slice(start, end);
  }

  // rows[i] is the client/matter object that produces filters[i] -- the bulk response's Results
  // array is guaranteed the same length/order as the filters we send, so a result can be matched
  // back to its row by index without needing a server-generated id. Scoped to visibleClients()
  // (the current page) to match createSelected()'s existing behavior -- selecting via the header
  // "select all" checkbox spans every page, but only the current page is ever submitted by one
  // "Create" click today; this intentionally mirrors that rather than changing it.
  function buildSelectedFilters() {
    const clients = visibleClients();
    const rows = [];
    const filters = [];
    clients.forEach(client => {
      if (client.included && client.client.billing.billClient) {
        const matters = client.matters.filter(m => m.included);
        if (matters.length) {
          if (calculateTotalInMatters(matters)) return;
          rows.push(client);
          filters.push(buildFilterRequest(client, matters));
        }
      } else {
        const matters = client.matters.filter(m => m.included);
        matters.forEach(matter => {
          if (!matter.include?.charges && !calculateTotalInMatter(matter)) return;
          rows.push(matter);
          filters.push(buildFilterRequest(matter, undefined));
        });
      }
    });
    return {
      rows,
      filters
    };
  }

  // Recomputed every digest rather than hooked to specific mutation points -- selection can
  // change via the per-row checkbox, the header "select all", or implicitly by paging/searching/
  // sorting (all of which change what visibleClients() returns), and a manually-hooked count
  // would need to catch every one of those to stay accurate.
  $scope.$watch(() => buildSelectedFilters().filters.length, count => {
    $scope.selectedCount = count;
  });

  // leanLawApi rejects with { status, header, config, body } -- config carries the request's
  // Authorization header, so row.error (rendered verbatim in the invoice-table-row popover) must
  // never be assigned that object directly. Only body.message (the backend's curated
  // UserException text) is safe to surface.
  function safeInvoiceErrorMessage(err, fallback = 'Failed to create this invoice.') {
    return err?.body?.message || fallback;
  }
  function createSelected() {
    if (!$scope.me?.features?.batchDraftInvoice) {
      return createSelectedLegacy();
    }
    let message = `This will create draft invoices for all selected clients/${$scope.me.terms.matter}s.`;
    let successMessagePlural = 'Draft invoices successfully created';
    const {
      rows,
      filters
    } = buildSelectedFilters();
    if (!filters.length) {
      $scope.showSelectMessage = true;
      return;
    }
    if (!$scope.draft) {
      message = `This will create invoices for all selected clients/${$scope.me.terms.matter}s and send them to QuickBooks.`;
      successMessagePlural = 'Invoices successfully created and sent to QuickBooks';
    }
    bootbox.confirm(message, yes => {
      if (!yes) return;
      runBulkCreate(rows, filters, successMessagePlural);
    });
  }
  function createSelectedLegacy() {
    let message = `This will create draft invoices for all selected clients/${$scope.me.terms.matter}s.`;
    let successMessagePlural = 'Draft invoices successfully created';
    const clients = visibleClients();
    const selected = clients.find(client => client.matters.find(matter => matter.included));
    if (!selected) {
      $scope.showSelectMessage = true;
      return;
    }
    if (!$scope.draft) {
      message = `This will create invoices for all selected clients/${$scope.me.terms.matter}s and send them to QuickBooks.`;
      successMessagePlural = 'Invoices successfully created and sent to QuickBooks';
    }
    bootbox.confirm(message, yes => {
      if (yes) {
        let process = $q.resolve();
        $scope.creating = true;
        clients.forEach(client => {
          if (client.included && client.client.billing.billClient) {
            const matters = client.matters.filter(m => m.included);
            if (matters.length) {
              if (calculateTotalInMatters(matters)) return;
              process = process.then(() => create(client, matters, 'bulk-create'));
            }
          } else {
            const matters = client.matters.filter(m => m.included);
            matters.forEach(matter => {
              if (!matter.include?.charges && !calculateTotalInMatter(matter)) return;
              process = process.then(() => create(matter, undefined, 'bulk-create'));
            });
          }
        });
        process.then(() => {
          alerts.success(successMessagePlural);
          onboardService.reload();
          stateUpdated(true);
        }).catch(err => {
          alerts.error(err);
        }).finally(() => {
          $scope.creating = false;
        });
      }
    });
  }

  // The chunk loop itself lives in bulkCreateStore.runBulkCreate, so it keeps running even if
  // this controller is destroyed by an in-app navigation partway through -- there's no
  // navigation guard here any more because there's nothing left it needs to guard. This
  // function's job is just: paint live per-row feedback while it's mounted to watch, and (if
  // it's still mounted when the whole run finishes) refresh the list and surface a toast.
  async function runBulkCreate(rows, filters, successMessagePlural) {
    rows.forEach(row => {
      row.creating = true;
      row.error = null;
    });
    const rowKeys = rows.map(row => row.client ? `client:${row.client.id}` : `matter:${row.matter.id}`);
    const rowsByKey = new Map(rows.map((row, index) => [rowKeys[index], row]));

    // Fires after each chunk's response/catch -- lets the currently-rendered table update
    // immediately instead of waiting for the whole run (and a fresh fetch) to reflect it.
    // A no-op once this controller is destroyed: rowsByKey only holds rows from the fetch
    // that was current when this run started, and nothing renders them any more.
    const onChunkComplete = chunkResults => {
      if (destroyed) return;
      chunkResults.forEach(({
        rowKey,
        error
      }) => {
        const row = rowsByKey.get(rowKey);
        if (row) {
          row.creating = false;
          row.error = error;
        }
      });
      $scope.$applyAsync();
    };
    await bulkCreateStore.runBulkCreate({
      filters,
      rowKeys,
      method: 'bulk-create',
      draft: $scope.draft,
      successMessagePlural,
      onChunkComplete
    });

    // If this controller was destroyed mid-run (the user navigated away), there's nothing left
    // to refresh here -- the next real visit to Ready to Bill fetches fresh data itself, and
    // stateUpdated() already calls bulkCreateStore.applyResultsToRows after every fetch, so
    // results are reapplied without this trailing block needing to run. The global banner
    // (BulkInvoiceCreateBanner.vue) already showed the outcome independently of whether this
    // controller is still around to see it.
    if (destroyed) return;
    const summary = bulkCreateStore.lastRunSummary;
    if (summary) {
      if (summary.failedCount === 0) {
        alerts.success(summary.successMessagePlural);
      } else if (summary.failedCount === summary.total) {
        alerts.error(`Failed to create ${summary.failedCount} invoice(s). See the affected rows for details.`);
      } else {
        alerts.warning(`${summary.total - summary.failedCount} of ${summary.total} invoice(s) created; ${summary.failedCount} failed. See the affected rows for details.`);
      }
    }
    onboardService.reload();
    await stateUpdated(true);
  }
  const calculateTotalInMatter = matter => {
    return (matter.include?.billable ? matter.data.amounts.hours : 0) + (matter.include?.charges ? matter.data.amounts.charges : 0) + (matter.include?.expenses ? matter.data.amounts.expenses : 0);
  };
  const calculateTotalInMatters = matters => {
    let matterWithZeroTotal = false;
    matters.forEach(matter => {
      if (!matter.include?.charges && !calculateTotalInMatter(matter)) {
        matterWithZeroTotal = true;
      }
    });
    return matterWithZeroTotal;
  };
  function createClient(selectedMatterOrClient, matters, method = 'quick-create') {
    const successMessageSingular = $scope.draft ? 'Draft invoice successfully created' : 'Invoice successfully created and sent to QuickBooks';
    const includeMatters = selectedMatterOrClient.matters.filter(m => m.included);
    if (includeMatters.length > 0) {
      matters = includeMatters;
    }
    create(selectedMatterOrClient, matters, method).then(invoice => {
      alerts.success(successMessageSingular);
      onboardService.reload();
      stateUpdated(true);
    });
  }
  function createMatter(matter, method = 'quick-create') {
    let successMessageSingular = 'Draft invoice successfully created';
    if (!$scope.draft) {
      successMessageSingular = 'Invoice successfully created and sent to QuickBooks';
    }
    create(matter, undefined, method).then(invoice => {
      alerts.success(successMessageSingular);
      onboardService.reload();
      stateUpdated(true);
    });
  }
  function rowChecked() {
    $scope.showSelectMessage = false;
  }
  function clicked(row, {
    quick,
    builder,
    bulkCreate
  }, selectedMatterRow) {
    if (quick || bulkCreate) {
      const method = quick ? 'quick-create' : 'bulk-create';
      if (row.client) {
        return createClient(row, selectedMatterRow, method);
      }
      return createMatter(row, method);
    }
    const route = builder ? 'builder' : 'matter';
    if (row.client) {
      return clientSelected(row, route, selectedMatterRow);
    }
    matterSelected(row, route);
  }
  function buildFilterRequest(clientOrMatter, matters) {
    const filter = invoiceFilterService.filterQuery();
    const request = {
      clientId: clientOrMatter.client ? clientOrMatter.client.id : null,
      matterIds: matters ? matters.map(m => m.matter.id) : null,
      matterId: clientOrMatter.matter ? clientOrMatter.matter.id : null,
      startDate: filter.startDate,
      endDate: filter.endDate,
      include: clientOrMatter.include,
      timeOffset: new Date().getTimezoneOffset(),
      checkboxesChecked: getCheckboxesChecked()
    };
    if (invoiceFilterService.state.expenseRange) {
      const expenseRequest = invoiceFilterService.expenseFilterQuery();
      request.expenseRange = {
        startDate: expenseRequest.startDate,
        endDate: expenseRequest.endDate
      };
    }
    return request;
  }
  function create(clientOrMatter, matters, method = 'quick-create') {
    const request = buildFilterRequest(clientOrMatter, matters);
    clientOrMatter.creating = true;
    return leanLawApi.createInvoice({
      body: {
        method,
        filter: request
      }
    }).then(invoice => invoice).catch(err => {
      alerts.error(err);
      clientOrMatter.creating = false;
      clientOrMatter.error = safeInvoiceErrorMessage(err);
      return {
        error: clientOrMatter.error
      };
    });
  }
  function clientSelected(client, route, matters) {
    const includeMatters = client.matters.filter(m => m.included);
    if (includeMatters.length > 0) {
      matters = includeMatters;
    }
    $state.go(`^.${route}`, {
      clientId: client.client.id,
      mattersIds: matters ? matters.map(m => m.matter.id) : null
    });
  }
  function matterSelected(matter, route) {
    $state.go(`^.${route}`, {
      matterId: matter.matter.id
    });
  }
  function selectColumn(column) {
    const value = $scope.include[column];
    $scope.data.clients.forEach(client => {
      client.include[column] = value;
      if (column === 'charges' && value === false) {
        client.include['chargeHours'] = false;
        $scope.include.chargeHours = false;
      } else if (column === 'chargeHours' && value === true) {
        client.include['charges'] = true;
        $scope.include.charges = true;
      }
      client.matters.forEach(matter => {
        matter.include[column] = value;
        if (column === 'charges' && value === false) {
          matter.include['chargeHours'] = false;
        } else if (column === 'chargeHours' && value === true) {
          matter.include['charges'] = true;
        }
      });
    });
  }
}]);